import { ProductModel } from 'CommonData/poco/index';
import { FilterMapper} from 'CommonData/mappers/index';

export class ProductModelMapper {
    public static map(data: any): Array<ProductModel> {
        if (!data) {
            throw 'No data for mapper: ProductModelMapper';
        }

        return data.models.map((m: any) => 
            new ProductModel({
                name: m.name,
                modelUrl: `https://media.marshalls.co.uk/image/upload/VisualisationProps/${m.modelUrl}`,
                swatchUrl: m.swatchUrl || `https://media.marshalls.co.uk/image/upload/VisualisationProps/${m.relativeSwatchUrl}`,
                filters: FilterMapper.map(m),
                categoryType: m.categoryType
            })
        );
    }
} 